module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sc-message--emoji"
  }, [_vm._v(_vm._s(_vm.data.emoji))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-232176dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-beautiful-chat/src/EmojiMessage.vue
// module id = 1216
// module chunks = 1